import React from 'react'

const TVSA = () => {
  return (
    <div className="tvsa__container">
      <div className="tvsa__title">
        <h1>My Time with the Thai Vietnamese Student Association (TVSA)</h1>
      </div>
      <div className="tvsa__roles">
        <h3 className="tvsa__ivp__tit">Internal Vice President '23-'24</h3>
        <h3 className="tvsa__ivp__tit">External Vice President '24-'25</h3>
      </div>
      
    </div>
  )
}

export default TVSA
